import {ParamsProps} from '@/components/WdiBus/FormPage';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {WdiModalAppResult} from '@/components/WdiControls';
import {FormApi} from '@/services/sales';
import {FormSs} from '@/services/sales/ss';
import {DataOptions} from '@/services/basic/metadata';
import {EC} from '@/services/mdm/ec';
import DataStore from '@/components/GridWidget/DataStore';

export type ViewEntityProps = {
  pageTypeId?: number;
  formTypeId?: number;
  formId?: number;
  relationType?: Enum.FormRelationType;
  relatedFormId?: number;
  formSaId?: number,
  saForm?: API.Form;
  form?: API.Form;
  formSs?: API.FormSs;
  formSsDetails?: API.FormSsDetail[],
  settlementMaterials?: API.DataOptions[];
  ecFieldConfigs?: API.EcFieldConfig[];
  sfaButton?: boolean;
}

export const initApplyPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  viewEntity.pageTypeId = Enum.PageType.ACTIVITY_SETTLEMENT;
  viewEntity.formTypeId = Enum.FormType.ACTIVITY_SETTLEMENT;
  if (params.formId || params.relatedFormId) {
    // 退回待修改
    const formResponse = await FormApi.get(params.formId || params.relatedFormId || 0);
    viewEntity.form = formResponse.data;
    if (!viewEntity.form) {
      result.message = "无效的退回待修改单";
      return result;
    }

    if (params.formId) {
      viewEntity.formId = params.formId;
    } else {
      viewEntity.relationType = Enum.FormRelationType.REJECTED;
      viewEntity.relatedFormId = params.relatedFormId;
    }

    const formSSResponse = await FormSs.get(viewEntity.form.formId);
    viewEntity.formSs = formSSResponse.data;
    viewEntity.formSaId = viewEntity.formSs.formSaId;
  } else {
    viewEntity.formSaId = params.formSaId;
  }

  const settlementMaterials = await DataOptions.GetSettlementMaterials(Number(viewEntity.formSaId));
  viewEntity.settlementMaterials = settlementMaterials?.data;

  const ecFieldConfigsResponse = await EC.getEcFieldConfigs();
  viewEntity.ecFieldConfigs = ecFieldConfigsResponse.data;

  const formSsDetailsResponse = await FormSs.getFormSsDetailsForApply({
    formSaId: viewEntity.formSaId,
    formSsId: viewEntity.formSs?.formSsId
  });
  viewEntity.formSsDetails = DataStore.init(formSsDetailsResponse.data);

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
}

export const initApprovalPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId) {
    const formSSResponse = await FormSs.get(params.formId);
    viewEntity.formSs = formSSResponse.data;
    if (!viewEntity.formSs) {
      result.message = "无效的草稿单";
      return result;
    }
    const formResponse = await FormApi.get(params.formId);
    viewEntity.form = formResponse.data;

    const settlementMaterials = await DataOptions.GetSettlementMaterials(Number(viewEntity.formSs.formSaId));
    viewEntity.settlementMaterials = settlementMaterials?.data;

    const formSsDetailsResponse = await FormSs.getFormSsDetailsForApproval(params.formId);
    viewEntity.formSsDetails = DataStore.init(formSsDetailsResponse.data);
    const allowSfaRes = await FormSs.Buttons.allowSfa({formId: params.formId});
    if (allowSfaRes.data) {
      viewEntity.sfaButton = allowSfaRes.data?.success;
    }
  }

  const ecFieldConfigsResponse = await EC.getEcFieldConfigs();
  viewEntity.ecFieldConfigs = ecFieldConfigsResponse.data;

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
}

export const replaceColumns = {
  'soldToCode': [
    {name: 'soldToCode', displayName: '售达方编号'},
    {name: 'soldToName', displayName: '售达方名称'},
  ],
  'shipToCodes': [
    {name: 'shipToNames', displayName: '送达方'},
  ],
  'ecId': [
    {name: 'ecName', displayName: '费用项'},
  ],
  'revenueType': [
    {name: 'revenueTypeName', displayName: '核算类型'},
  ],
  'promotionTypeId': [
    {name: 'promotionTypeName', displayName: '促销形式'},
  ],
  'paymentMethodId': [
    {name: 'paymentMethodName', displayName: '支付方式'},
  ],
  'boId': [
    {name: 'boName', displayName: '四级使用部门'},
  ],
  'custSysCode': [
    {name: 'custSysName', displayName: '客户系统'},
  ],
  'toSfa': [
    {name: 'toSfa', displayName: '是否同步到SFA', type: Enum.FieldType.BOOLEAN},
  ],
  'scheduleTypeId': [
    {name: 'scheduleTypeName', displayName: '档期类型'},
  ],
  'displayTypeIds': [
    {name: 'displayTypeNames', displayName: '陈列形式'},
  ],
  'popularizeTypeId': [
    {name: 'popularizeTypeName', displayName: '推广形式'},
  ],
  'syncStatus': [
    {name: 'syncStatusName', displayName: '同步状态'},
  ],
  'syncStatus1': [
    {name: 'syncStatusName', displayName: '同步状态(SFA)'},
  ],
};

